import { BCMSCurrency, BCMSDate, BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import Util from "classes/Util";
import SingleWirePage, { getDefaultData } from "components/pages/SingleWirePage";
import Classes, { Account, OneTimeWireTransfer, Payee, WireHistory } from "model";
import { useEffect } from "react";
export default function CaptureSingleWireConfirmation(props) {
  const context = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, context);
  const { branding } = context.state;
  const allWireHistory = WireHistory.initAll()
    .filter(item => item.id !== undefined)
    .sort((a, b) => parseFloat(b.referenceNumber) - parseFloat(a.referenceNumber))
let hasLOC = context.state.branding.options.loc_primary_abi22 == "true"; 
  let hasConsumer = context.state.branding.options.show_consumer_accts_abi22 == "true";  
  let locAccount = hasConsumer ? Account.initByID(9) :Account.initByID(10);
  let nonLocAccount = hasConsumer ? Account.initByID(1) :Account.initByID(5);
  let selectedAccount = hasLOC ? locAccount :nonLocAccount;
  const lastReferenceNumber = parseFloat(allWireHistory[0].referenceNumber) + 1
 

  const wireTransfer = OneTimeWireTransfer.init({
    id: OneTimeWireTransfer.nextID(),
    date: BCMSDate.init().offsetDay(5),
    amount: BCMSCurrency.init("1.00"),
    fundingAccount: selectedAccount,
    initiatedBy: Payee.initByID(0).name,
    name: Payee.initByID(0).name,
    referenceNumber: '00' + lastReferenceNumber
  });

  const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update(["createdOneTimeWireTransfer"], wireTransfer)
    .update(["wireTransferSubmitted"], true)
    .submit();
useEffect(() => {
        Util.replaceDOMDataPointValues(branding);
    });
  return (
    <SingleWirePage data={data} />
  )
}
